/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Fragment, useState, useEffect } from 'react';
import style from './attributes1Style';
import { MdMenuOpen, MdClose, MdCheck } from "react-icons/md";
import { createPortal } from "react-dom";

function Portal({children}){
    const [el] = useState(document.createElement('div'));
    useEffect(() => {
        let mount = document.getElementById("portal-root");
        mount.appendChild(el);
      return () => mount.removeChild(el);
    }, [el]);
    return createPortal(children, el);
}

export function Attributes({attributes, resetFormChange}){
    
    const [openPopup, setOpenPopup] = useState(false);
    const attributesItems = attributes.controls;

    function openAttributeOptions(e){
        setOpenPopup(true);
        document.body.style.overflow = "hidden";
    }

    function closeAttributeOptions(e){
        setOpenPopup(false);
        resetFormChange();
        document.body.style.overflow = "unset";
    }
    
    return (
        <Fragment>
            {
                attributesItems.length > 0 ?
                    <Fragment>
                        {
                            openPopup &&
                            <Portal>
                                <div css={style.portal__background} className='portal__background' onClick={closeAttributeOptions}></div>
                                <div css={style.portal__popupcontainer} className="portal__popupcontainer">
                                    {/* <SelectAttributeItem attributes={attributesItems} closeAttributeOptions={closeAttributeOptions} /> */}
                                        <div css={style.select__attribute} className="select__attribute">
                                            <div css={style.selectattribute__title} className="selectattribute__title">
                                                Attribute Options
                                                <div className='selectattribute__close' onClick={closeAttributeOptions}>
                                                    <MdClose />
                                                </div>
                                            </div>
                                            {
                                                attributesItems.map((item, index) => <SelectAttributeItem key={index} item = {item} />)
                                            }
                                        </div>
                                </div>
                            </Portal>
                        }
                        <div
                            css={style.attributes__wrap}
                            className="attributes__wrap"
                            onClick={openAttributeOptions}
                        >
                            <div css={style.attributes__title} className="attributes__title">
                                <div className="attr__arrow">
                                    <MdMenuOpen />
                                </div>
                                <div className="attr__text">Attributes</div>
                            </div>
                            {attributes.controls.map((item, index) => (
                                <AttributeItem key={index} items={item.controls} />
                            ))}
                        </div>
                    </Fragment> : <NoAttributeItem />
            }
        </Fragment>
    );
}

function AttributeItem({items}){
    return(
        <div css={style.attributeItem__container} className="attributeItem__container">
            <div className='attributeItem__item__name'>{ items[0].value} : </div>
            <div className='attributeItem__item__value'>{items[1].value} </div>
        </div>
    )
}

function NoAttributeItem(){
    return(
        <div>No Attributes</div>
    )
}

function SelectAttributeItem({item}){    
    const [value, setValue] = useState(item.controls[1].value);
    function changeValue(s_item){
        item.controls[1].value = s_item.value;
        item.controls[2].value = s_item.value;
        setValue(s_item.value);
    }

    return(
        <div css={style.selectattribute__item} className='selectattribute__item'>
            <div css={style.selectattribute__item__name} className='selectattribute__item__name'>
                {value}
            </div>
            {
                item.controls[1].options.map((s_item, s_index) =>
                    <div key={s_index} css={style.selectattribute__item__options} className={`selectattribute__item__options ${value === s_item.value ? "selected" : ""}`}
                        onClick={() => {changeValue(s_item)}}>
                        <span className={`check ${value === s_item.value ? "selected" : ""}`}>
                            {
                                value === s_item.value &&
                                <MdCheck />
                            }
                        </span>
                        <span className='name'> {s_item.name} </span>
                    </div>
                )
            }
        </div>
    )
}